import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center-col p-4 pt-0",
  id: "user-info"
};
import { computed } from "vue";
import UserProfile from "@/components/UserProfile.vue";

// eslint-disable-next-line no-undef

export default {
  __name: 'UserInfoDialog',
  props: {
    show: Boolean
  },
  emits: ["hide"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const showDialog = computed(() => {
      return props.show;
    });

    // eslint-disable-next-line no-undef
    const emits = __emit;
    const close = function () {
      emits("hide", false);
    };
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "config-dialog",
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        "before-close": close,
        style: {
          "max-width": "400px"
        },
        title: "账户信息"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(UserProfile, {
          onHide: close
        })])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};